import { render, staticRenderFns } from "./TripStatsIcon.vue?vue&type=template&id=21db8f8c"
import script from "./TripStatsIcon.vue?vue&type=script&lang=ts"
export * from "./TripStatsIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports